// Middleware
import GuestMiddleware from '@middleware/GuestMiddleware';

// Layouts
import LayoutAuth from '@layouts/LayoutAuth';

export default {
    path: '/',
    component: LayoutAuth,
    children: [
        {
            path: '',
            name: 'home',
            component: () => import('@pages/auth/PageAuthLogin'),
            meta: {
                middleware: GuestMiddleware,
            },
        },
    ],
};